import BlindsAndShuttersRawCondition from './BlindsAndShuttersRawCondition';

export default BlindsAndShuttersRawCondition;